document.addEventListener("alpine:init", () => {
  Alpine.data(
    "bundles",
    ({
      otpFirst,
      badgePattern,
      pricePattern,
      currencyDivider,
      displayCompareAtPrice,
      displaySubscriptionBadge,
      displayOTPBadge,
    }) => {
      return {
        products: [],
        flavors: [],
        currentFlavor: null,
        bundleForm: null,
        displayCompareAtPrice: displayCompareAtPrice == "true",
        displaySubscriptionBadge: displaySubscriptionBadge == "true",
        displayOTPBadge: displayOTPBadge == "true",
        badgePattern: badgePattern ?? "[amount]",
        pricePattern: pricePattern ?? "[amount]",
        currencyDivider: currencyDivider ?? 100,
        purchaseTypes: null,
        purchaseType: null,
        isSubscription: false,
        otpFirst: otpFirst || false,

        init() {
          this.bundleForm = this.$refs.bundleForm;
          this.products = JSON.parse(this.$refs.productsData.textContent);
          this.purchaseTypes = JSON.parse(this.$refs.purchaseTypes.textContent);
          this.prepareFlavorsData();

          this.changeSelectedPurchaseType(
            this.otpFirst ? "otp" : "subscription"
          );

          console.log(this.products);
        },

        formatBenefits(benefits) {
          if (!benefits) return "";

          let html = `<ul class="ctr-bundle__item-list">
            ${benefits
              .split("\n")
              .map((benefit) => {
                return `<li>${benefit
                  .replace(
                    "[icon-delivery]",
                    "<span class='ctr-icon m-delivery'></span>"
                  )
                  .replace(
                    "[icon-time]",
                    "<span class='ctr-icon m-time'></span>"
                  )}</li>`;
              })
              .join("")}
          </ul>`;

          return html;
        },
        prepareFlavorsData() {
          if (!this.products) return;
          this.flavors = [];

          this.products.forEach(
            ({
              product,
              metafields,
              custom_bundle_image: customBundleImage,
              custom_bundle_title: customBundleTitle,
              promotional_price: promotionalPrice,
            }) => {
              let alternativeImage = customBundleImage || null;
              let benefits = "";
              const firstVariant = product.variants[0];

              const flavorImage =
                alternativeImage ||
                firstVariant.featured_image ||
                product.featured_image;
              const variantPrice = Number(firstVariant.price || 0);
              const productCompareAt = Number(product.compare_at_price || 0);
              const variantCompareAt = Number(firstVariant.compare_at_price || 0);

              // Use the regular one-time "reference" price for savings math:
              // prefer compare_at_price (if higher than current), else fallback to current price.
              const oneTimeReferencePrice =
                (productCompareAt && productCompareAt > variantPrice)
                  ? productCompareAt
                  : (variantCompareAt && variantCompareAt > variantPrice)
                    ? variantCompareAt
                    : variantPrice;

              const subscriptionPrice =
                firstVariant.selling_plan_allocations[0].price;
              const subscriptionOldPrice = oneTimeReferencePrice;

              this.flavors.push({
                parentId: product.id,
                id: firstVariant.id,
                title: customBundleTitle || product.title,
                description: product.description,
                image: flavorImage,
                benefitsOtp: this.formatBenefits(
                  metafields.bundle_benefits_otp
                ),
                benefitsSubscription: this.formatBenefits(
                  metafields.bundle_benefits
                ),
                refillText: metafields.bundle_refill_text,
                link: {
                  handle: product.handle,
                  url: `/products/${product.handle}`,
                },
                prices: {
                  otp: {
                    currentPrice: firstVariant.price,
                    compareAtPrice: oneTimeReferencePrice > variantPrice ? oneTimeReferencePrice : null,
                  },
                  subscription: {
                    currentPrice: subscriptionPrice,
                    oldPrice: subscriptionOldPrice,
                  },
                },
                savings: {
                  otp: promotionalPrice
                    ? (oneTimeReferencePrice - promotionalPrice)
                    : (oneTimeReferencePrice - firstVariant.price),
                  subscription: promotionalPrice
                    ? (oneTimeReferencePrice - promotionalPrice)
                    : (oneTimeReferencePrice - subscriptionPrice),
                },
                badge_text: {
                  otp: promotionalPrice
                    ? `${badgePattern.replace(
                        "[percentage]",
                        Math.floor(
                          ((oneTimeReferencePrice - promotionalPrice) / oneTimeReferencePrice) * 100
                        )
                      )}%`
                    : `${badgePattern.replace(
                        "[percentage]",
                        Math.floor(
                          ((oneTimeReferencePrice - firstVariant.price) / oneTimeReferencePrice) * 100
                        )
                      )}%`,
                  subscription: promotionalPrice
                    ? `${badgePattern.replace(
                        "[percentage]",
                        Math.floor(
                          ((oneTimeReferencePrice - promotionalPrice) / oneTimeReferencePrice) * 100
                        )
                      )}%`
                    : `${badgePattern.replace(
                        "[percentage]",
                        Math.floor(
                          ((subscriptionOldPrice - subscriptionPrice) /
                            subscriptionOldPrice) *
                            100
                        )
                      )}%`,
                },
                selling_plan: firstVariant.selling_plan_allocations[0],
                promotionalPrice: promotionalPrice ? promotionalPrice : null,
              });
            }
          );
          this.currentFlavor = this.flavors[0];
        },

        updateForm() {
          const parentIdField = this.bundleForm.querySelector(
            'input[name="product-id"]'
          );
          const variantIdField =
            this.bundleForm.querySelector('input[name="id"]');
          const sellingPlanField = this.bundleForm.querySelector(
            'input[name="selling_plan"]'
          );

          parentIdField.value = this.currentFlavor.parentId;
          variantIdField.value = this.currentFlavor.id;
          sellingPlanField.value = this.isSubscription
            ? this.currentFlavor.selling_plan.selling_plan_id
            : "";
        },

        changeSelectedFlavor(flavorId) {
          this.currentFlavor = this.flavors.find(
            (flavor) => flavor.id == flavorId
          );

          this.updateForm();
        },

        changeSelectedPurchaseType(purchaseTypeId) {
          this.purchaseType = this.purchaseTypes.find(
            (type) => type.id === purchaseTypeId
          );

          this.isSubscription = this.purchaseType?.id === "subscription";

          this.updateForm();
        },

        formatPrice(price) {
          if (!price) return this.pricePattern.replace("[amount]", "0.00");

          return this.pricePattern.replace(
            "[amount]",
            (price / this.currencyDivider).toFixed(2)
          );
        },
      };
    }
  );
});
